export const injectRestAuthTokenToObject = targetObject => {
    targetObject._wpnonce = themeVars.restAuthToken;
    return targetObject;
}

export const getRestAuthHeader = () => ['X-WP-Nonce', themeVars.restAuthToken];


// WEBPACK FOOTER //
// ./scripts/modules/rest-api-helpers.js